/* eslint-disable indent */
import React from 'react';

import i18n from 'i18';

// @mui
import { TableCell } from '@mui/material';
import Label from '../../components/label';
import { getDisplayValue } from '../../utils/formatName';

// Text, Number, Items cells are similar
const mapIconColorByRole = (role) => {
    switch (role) {
        case 'ecoo':
            return '#16C1BC';
        case 'merchant':
            return '#9E77ED';
        case 'partner':
            return '#9E77ED';
        case 'user':
            return '#4592FF';
        default:
            return '#4592FF';
    }
};
export default class GridLabelCell extends React.Component {
    render() {
        // props: value, id, field
        const { field, value } = this.props;
        const color = field.color || 'default';
        const displayValue = getDisplayValue(value, field, this.props.row);

        const iconColor = mapIconColorByRole(displayValue);

        const startIcon = (
            <span
                style={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    display: 'inline-block',
                    marginRight: 3,
                    backgroundColor: iconColor
                }}
            ></span>
        );

        const translatedValue = (() => {
            const translationKey = `enums.${displayValue}`;
            const translated = i18n.t(translationKey);
            return translated === translationKey ? displayValue : translated;
        })();

        return (
            <TableCell key={this.props.field.id} align="left">
                <Label color={color} startIcon={startIcon}>
                    {translatedValue}
                </Label>
            </TableCell>
        );
    }
}
